import React from "react";
import Samples from "./components/Samples/index";
import Analysis from "./components/Analysis/index";

const routes = [
  {
    to: "/samples",
    exact: true,
    title: "Samples",
    render: () => <Samples />
  },
  {
    to: "/analysis",
    exact: true,
    title: "Analysis",
    render: () => <Analysis />
  }
];

export default routes;
